/** 背景色（hex） */
export const BACKGROUND_COLOR = "#ACFEFF";
